import { useState, useEffect } from "react";

const STATS = [
  { label: "Portal Entries Tracked", value: "1,842" },
  { label: "Programs Indexed", value: "134" },
  { label: "Player Profiles", value: "4,200+" },
  { label: "Data Sources", value: "12" },
];

// Players only, with destination school — no teams, no weird numbers
const TICKER_ITEMS = [
  { name: "DJ Lagway", pos: "QB", to: "Baylor" },
  { name: "Sam Leavitt", pos: "QB", to: "LSU" },
  { name: "Dylan Raiola", pos: "QB", to: "Oregon" },
  { name: "Jordan Seaton", pos: "OT", to: "LSU" },
  { name: "John Henry Daley", pos: "EDGE", to: "Michigan" },
  { name: "Princewill Umanmielen", pos: "EDGE", to: "LSU" },
  { name: "Elic Ayomanor", pos: "WR", to: "Alabama" },
  { name: "Jeremiah Smith", pos: "WR", to: "Returning" },
  { name: "Tre Harris", pos: "WR", to: "NFL Draft" },
  { name: "Kyle McCord", pos: "QB", to: "Washington" },
];

const Ticker = ({ items }) => {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setOffset(o => o - 0.5), 20);
    return () => clearInterval(id);
  }, []);
  const totalW = 3200;
  const adj = ((offset % totalW) + totalW) % totalW;
  const displayed = [...items, ...items, ...items, ...items];
  return (
    <div style={{ overflow: "hidden", height: "28px", background: "#0f0f0f", position: "relative", flexShrink: 0 }}>
      <div style={{ display: "flex", position: "absolute", left: -adj, whiteSpace: "nowrap", alignItems: "center", height: "100%" }}>
        {displayed.map((item, i) => (
          <span key={i} style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "10px", letterSpacing: "0.04em", padding: "0 24px", borderRight: "1px solid #2a2a2a", color: "#ccc" }}>
            <span style={{ color: "#666", marginRight: "7px" }}>{item.pos}</span>
            <span style={{ color: "#e5e5e5", marginRight: "7px", fontWeight: 600 }}>{item.name}</span>
            <span style={{ color: "#888", marginRight: "5px" }}>→</span>
            <span style={{ color: "#4ade80" }}>{item.to}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default function Landing({ onEnter }) {
  const [visible, setVisible] = useState(false);
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    setTimeout(() => setVisible(true), 80);
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#f8f7f4", color: "#0f0f0f", fontFamily: "'IBM Plex Sans', sans-serif", display: "flex", flexDirection: "column" }}>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,700&family=IBM+Plex+Mono:wght@400;600;700&family=IBM+Plex+Sans:wght@300;400;600;700&display=swap" rel="stylesheet" />
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.4; } }
        .enter-btn { display: inline-flex !important; width: auto !important; }
        .enter-btn:hover { background: #0f0f0f !important; color: #fff !important; }

        @media (max-width: 768px) {
          .masthead { padding: 0 16px !important; height: 44px !important; }
          .hero-layout { flex-direction: column !important; }
          .hero-left { padding: 32px 20px 28px !important; border-right: none !important; border-bottom: 1px solid #e5e7eb !important; }
          .hero-right { width: 100% !important; padding: 28px 20px 32px !important; border-left: none !important; }
          .hero-h1 { font-size: 38px !important; letter-spacing: -0.5px !important; }
          .hero-sub { font-size: 14px !important; max-width: 100% !important; margin-bottom: 28px !important; }
          .enter-btn { width: 100% !important; justify-content: center !important; }
          .stat-number { font-size: 32px !important; }
          .stat-grid-mobile { display: grid !important; grid-template-columns: 1fr 1fr !important; }
          .stat-item-mobile { border-right: 1px solid #e5e7eb; padding-right: 16px !important; }
          .stat-item-mobile:nth-child(even) { border-right: none !important; padding-left: 16px !important; padding-right: 0 !important; }
          .footer-right { display: none !important; }
        }
      `}</style>

      {/* MASTHEAD */}
      <header className="masthead" style={{ background: "#0f0f0f", height: "48px", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 32px", flexShrink: 0 }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "18px", fontWeight: 900, color: "#fff", letterSpacing: "-0.3px" }}>
          GridironIQ
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: "#4ade80", animation: "pulse 2s infinite" }} />
            <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9px", color: "#888" }}>SPRING 2026 · LIVE</span>
          </div>
          <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9px", color: "#666" }}>
            {time.toLocaleTimeString("en-US", { hour12: false })} ET
          </span>
        </div>
      </header>

      {/* TICKER */}
      <Ticker items={TICKER_ITEMS} />

      {/* HERO */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", opacity: visible ? 1 : 0, animation: visible ? "fadeUp 0.5s ease forwards" : "none" }}>
        <div style={{ height: "1px", background: "#e5e7eb" }} />

        <div className="hero-layout" style={{ display: "flex", flex: 1 }}>

          {/* LEFT */}
          <div className="hero-left" style={{ flex: 1, padding: "72px 80px", borderRight: "1px solid #e5e7eb", display: "flex", alignItems: "center" }}>
            <div style={{ maxWidth: "500px" }}>
              <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9px", color: "#9ca3af", letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: "24px", display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "24px", height: "1px", background: "#d1d5db" }} />
                College Football Intelligence Platform
              </div>

              <h1 className="hero-h1" style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(38px, 4.5vw, 64px)", fontWeight: 900, color: "#0f0f0f", lineHeight: 1.05, marginBottom: "24px", letterSpacing: "-1px" }}>
                Every transfer.<br />
                <span style={{ fontStyle: "italic", fontWeight: 700 }}>Every player.</span><br />
                One platform.
              </h1>

              <p className="hero-sub" style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: "15px", fontWeight: 300, color: "#6b7280", lineHeight: 1.7, marginBottom: "36px" }}>
                Real-time portal tracking, graded player profiles, recruiting history, transfer timelines, and intelligence feeds — all in one place.
              </p>

              <button className="enter-btn" onClick={onEnter} style={{ background: "#fff", border: "1px solid #0f0f0f", color: "#0f0f0f", padding: "11px 28px", borderRadius: "2px", fontFamily: "'IBM Plex Mono', monospace", fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", cursor: "pointer", transition: "all 0.15s ease", display: "inline-flex", alignItems: "center", gap: "6px" }}>
                Enter →
              </button>
            </div>
          </div>

          {/* RIGHT — stats, visible on both desktop and mobile */}
          <div className="hero-right" style={{ width: "360px", flexShrink: 0, padding: "72px 56px", borderLeft: "1px solid #e5e7eb", display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "8px", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.16em", marginBottom: "24px" }}>
              Platform Overview
            </div>

            <div className="stat-grid-mobile">
              {STATS.map((s, i) => (
                <div key={s.label} className="stat-item-mobile" style={{ padding: "18px 0", borderBottom: "1px solid #e5e7eb", borderTop: i < 2 ? "1px solid #e5e7eb" : "none" }}>
                  <div className="stat-number" style={{ fontFamily: "'Playfair Display', serif", fontSize: "44px", fontWeight: 700, color: "#0f0f0f", lineHeight: 1, marginBottom: "6px" }}>{s.value}</div>
                  <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9px", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.12em" }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <footer style={{ background: "#0f0f0f", padding: "14px 32px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9px", color: "#555" }}>© 2026 GRIDIRONIQ · BETA</span>
            <span className="footer-right" style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: "9px", color: "#555" }}>DATA REFRESHED EVERY 15 MIN · SPRING PORTAL WINDOW OPEN</span>
          </div>
        </footer>
      </div>
    </div>
  );
}
